// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1687":"29b4f915b778f5c2","4044":"bb8fb8e8156be1b7"}[chunkId] + ".css";
};